import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, List } from 'lucide-react';
import PropTypes from 'prop-types';

const NavigationButtons = ({ listPath }) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-4 mb-6">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Torna indietro
      </button>
      <button
        onClick={() => navigate(listPath)}
        className="flex items-center px-4 py-2 text-gray-600 hover:text-gray-800"
      >
        <List className="w-4 h-4 mr-2" />
        Torna alla lista dei professionisti
      </button>
    </div>
  );
};

NavigationButtons.propTypes = {
  listPath: PropTypes.string.isRequired
};

export default NavigationButtons;